import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { CommonStandaloneModule } from '../../../../shared/common-standalone.module';
import { PillComponent } from '../../../../shared/components';
import { DashboardDevice, DashboardInstallationData } from '@vi-iot/client';
import { ACTIVE_ERROR_TYPE, InstallationType, KanbanBoardHelperService } from '@store';
import { AggregatedStatusPillPipe } from '../../pipes/aggregated-status-pill/aggregated-status-pill.pipe';
import { PillType } from '../../../../shared/components/pill/pill.model';
import { MatTooltip, MatTooltipModule } from '@angular/material/tooltip';
import { matTooltipSetter } from '../../../../shared/functions/mat-tooltip-setter/mat-tooltip-setter';
import { MatIconModule } from '@angular/material/icon';
import { DashboardOperatingModePipe } from '../../pipes/dashboard-operating-mode/dashboard-operating-mode.pipe';
import { DashboardAnomalyPillPipe } from '../../pipes/dashboard-anomaly-pill/dashboard-anomaly-pill.pipe';

@Component({
  selector: 'app-installation-tile-badges',
  standalone: true,
  templateUrl: './installation-tile-badges.component.html',
  styleUrls: ['./installation-tile-badges.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonStandaloneModule,
    PillComponent,
    AggregatedStatusPillPipe,
    MatTooltipModule,
    MatIconModule,
    DashboardOperatingModePipe,
    DashboardAnomalyPillPipe,
  ],
})
export class InstallationTileBadgesComponent implements OnInit {
  @ViewChildren(MatTooltip)
  set matTooltip(queryList: QueryList<MatTooltip>) {
    matTooltipSetter(queryList);
  }

  @Input({ required: true }) installation: DashboardInstallationData;
  @Input() isShowingAggregatedStatus: boolean;
  @Input() showDuplicationIcon: boolean;
  @Input() isInListView = false;

  readonly pillType = PillType;
  readonly installationType = InstallationType;

  isSingleDevice: boolean;
  mainDevice: DashboardDevice;
  errorCodes: string[];
  constructor(public kanbanBoardHelperService: KanbanBoardHelperService) {}

  ngOnInit(): void {
    this.isSingleDevice = this.installation?.devices.length === 1;
    this.mainDevice = this.installation?.devices?.find(
      (device) => this.installation.device?.vin === device?.vin
    );
    if (this.mainDevice) {
      this.setErrorCodes(this.mainDevice);
    }
  }
  private setErrorCodes(mainDevice: DashboardDevice): void {
    this.errorCodes = mainDevice.smartNotes
      .filter(
        (smartNote) =>
          smartNote.type === ACTIVE_ERROR_TYPE.DEVICE_ERROR && smartNote.content?.errorCode
      )
      .map((smartNote) => smartNote.content.errorCode);
  }
}
